export default __webpack_public_path__ + "static/media/gallery_03.9d063838.jpg";